import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    sexo: [],
  },

  getters: {
    getSexo: (state) => state.sexo,
  },

  mutations: {
    SET_SEXO(state, sexo) {
      state.sexo = sexo;
    },
  },

  actions: {
    async fetchSexo({ commit }) {
      await axios
        .get('EonCloud/sexo')
        .then((response) => {
          commit('SET_SEXO', response.data.data);
        });
    },
  },
};
